module.exports = __webpack_public_path__ + "img/Cosmic_Egg.2d38dda4.png";